export default __webpack_public_path__ + "static/media/react.05c3b859.png";